import { render, staticRenderFns } from "./ui-status.vue?vue&type=template&id=58336d35&scoped=true&"
import script from "./ui-status.vue?vue&type=script&lang=js&"
export * from "./ui-status.vue?vue&type=script&lang=js&"
import style0 from "./ui-status.vue?vue&type=style&index=0&id=58336d35&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58336d35",
  null
  
)

export default component.exports